<template>

  <div id="page-user-list">
    <data-view-sidebar :isSidebarActive="addNewDataSidebarEditDataClientPDN" @closeSidebar="toggleDataSidebarEditDataClientPDN" :data="sidebarDataEditDataClientPDN" v-on:closeSidebarSuccess="updateListClientsPDN" />
    <data-view-sidebar-change-inmigration :isSidebarActive="addNewDataSidebarChangeInmigration" @closeSidebar="toggleDataSidebarChangeInmigration" :data="sidebarDataChangeInmigration" v-on:closeSidebarSuccess="updateListClientsPDN"/>
    <vs-prompt
      @cancel="initValues"
      @accept="submitData"
      title="Agregar Nuevo Cliente"
      acceptText= "Crear"
      cancelText= "Cancelar"
      :is-valid="isFormValid"
      :active.sync="activePrompt">
      <VuePerfectScrollbar :settings="settings">
        <div class="con-exemple-prompt pb-24">
          <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Nombres (requerido)" v-model="names_client" class="w-full" name="names_client" v-validate="'alpha_spaces'" />
                  <span class="text-danger text-sm" v-show="errors.has('names_client')">{{ errors.first('names_client') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Apellidos (requerido)" v-model="surnames_client" class="w-full" name="surnames_client" v-validate="'alpha_spaces'" />
                  <span class="text-danger text-sm" v-show="errors.has('surnames_client')">{{ errors.first('surnames_client') }}</span>
              </div>
          </div>
          <div class="vx-row">
              <div class="vx-col w-full">
                  <vs-input label="Email (requerido)" v-model="email" class="w-full" name="email" v-validate="'required|email'" />
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
          </div>
          <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Contraseña (requerido)" placeholder="" v-model="password" class="w-full" name="password" v-validate="'required|min:8|max:15'" ref="password"/>
                  <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                  <vs-input label="Repetir contraseña (req.)" placeholder="" v-model="password_confirmation" class="w-full" name="password_confirmation" v-validate="'min:8|max:15|confirmed:password'" data-vv-as="password" />
                  <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
              </div>
          </div>
          <div class="vx-row">
            <hr>
          </div>
          <!-- TELEFONOS -->
          <div class="vx-row px-4">
            <div class="w-full">
                <vs-input label="Telf Móvil (opcional)" v-model="phone_mobile_client" placeholder="0584166889887" class="w-full" name="phone_mobile_client" />
                <span class="text-danger text-sm" v-show="errors.has('phone_mobile_client')">{{ errors.first('phone_mobile_client') }}</span>
            </div>
          </div>
          <!-- PAIS  -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <label class="vs-input--label">País de procedencia <small>(donde se encuentra ahora mismo)</small></label>
              <v-select :closeOnSelect="true" v-model="id_country" label="name_country" :options="countries" name="id_country" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
          </div>

          <!-- 1RA NACIONALIDAD  Y 2DA NACIONALIDAD-->
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">1ra Nacionalidad</label>
              <v-select :closeOnSelect="true" v-model="id_first_nationality" label="name_country" :options="countries" name="id_first_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">2da Nacionalidad</label>
              <v-select :closeOnSelect="true" v-model="id_second_nationality" label="name_country" :options="countries" name="id_second_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </vs-prompt>
    <!-- PROMPT PARA CONFIRMAR BORRADO DE SERVICIO DE EXTRANJERÍA -->
      <vs-prompt
        @cancel="val=''"
        @accept="confirmRemoveInmigration"
        title="Confirmar remoción de servicio extranjería"
        acceptText= "Remover"
        cancelText= "Cancelar"
        :is-valid="validWord"
        :active.sync="activePromptRemoveInmigration">
        <div class="con-exemple-prompt">
          <span>¿Está seguro de remover el servicio de extranjería a: <strong>{{params.data.names_client}} {{params.data.surnames_client}}</strong>?</span>
          <p class="mt-3">Escriba "remover extranjería" para continuar</p>
          <vs-input placeholder="Escriba 'remover extranjería'" vs-placeholder="Escriba 'remover extranjería'" v-model="val" class="w-full" />
        </div>
      </vs-prompt>
      <!-- /PROMPT PARA CONFIRMAR BORRADO DE SERVICIO DE EXTRANJERÍA -->
      <!-- PROMPT PARA CAMBIAR PASSWORD -->
      <vs-prompt
        @cancel="initValues"
        @accept="changePassword"
        title="Cambiar Password de cliente"
        acceptText= "Cambiar contraseña"
        cancelText= "Cancelar"
        :is-valid="isFormValid"
        :active.sync="activePromptChangePassword">
        <div class="con-exemple-prompt">
          <div class="vx-row">
            <div class="vx-col w-full">
                <vs-input label="Nombre Cliente" :value="`${params.data.names_client} ${params.data.surnames_client}`" class="w-full" disabled/>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <vs-input label="Email Cliente" :value="`${params.data.email_user}`" class="w-full" disabled/>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full">
                <vs-input label="Contraseña (requerido)" placeholder="" v-model="password" class="w-full" name="password" v-validate="'required|min:8|max:15'" ref="password"/>
                <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
          </div>
          <div class="vx-row mt-2">
              <div class="vx-col w-full">
                  <vs-input label="Repetir contraseña (requerido)" placeholder="" v-model="password_confirmation" class="w-full" name="password_confirmation" v-validate="'min:8|max:15|confirmed:password'" data-vv-as="password" />
                  <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
              </div>
          </div>
        </div>
      </vs-prompt>
      <!-- /PROMPT PARA CAMBIAR PASSWORD -->
      <!-- PROMPT PARA CAMBIAR EL ASESOR DEL CLIENTE -->
      <vs-prompt
        @cancel="val=''"
        @accept="changeAdvisor"
        title="Cambiar asesor del cliente"
        acceptText= "Cambiar Asesor"
        cancelText= "Cancelar"
        :is-valid="isFormValidChangeAdvisor"
        :active.sync="activePromptChangeAdvisor">
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
          <div class="con-exemple-prompt2 pb-32">
            <div class="vx-row">
              <div class="vx-col w-full">
                  <vs-input label="Nombre Cliente" :value="`${params.data.names_client} ${params.data.surnames_client}`" class="w-full" disabled/>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <vs-input label="Email Cliente" :value="`${params.data.email_user}`" class="w-full" disabled/>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-2">
                <label class="vs-input--label">Cambiar asesor:</label>
                <v-select :closeOnSelect="true" v-model="id_employee" label="name_employee" :options="employees" name="id_employee" :reduce="employees => employees.id_employee">
                  <template #option="{ name_employee, surname_employee }">
                    <span>{{ name_employee }} {{ surname_employee }}</span>
                  </template>
                  <template #selected-option="{ name_employee, surname_employee }">
                    <span>{{ name_employee }} {{ surname_employee }}</span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </vs-prompt>
      <!-- /PROMPT PARA CAMBIAR EL ASESOR DEL CLIENTE -->
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
            <!-- ADD NEW -->
          <div class="float-left btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="openCloseModal()">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Agregar Nuevo</span>
          </div>
        </div>
        

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu class="ancho-dropdown">

              <vs-dropdown-item>
                <span title="Descargar Todo" class="flex items-center" @click.stop="exportarCsvAll()">
                  <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Todo CSV</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span title="Descargar Seleccionados" class="flex items-center" @click.stop="exportarCsvSelected()">
                  <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Seleccionados CSV</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center" v-on:click="sizeToFit()">
                  <feather-icon icon="Minimize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Ancho ajustado</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center" v-on:click="autoSizeAll()">
                  <feather-icon icon="Maximize2Icon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Ancho Automático</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :frameworkComponents="frameworkComponents"
        @grid-ready="onGridReady"
        :context="context"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault=""
        :animateRows="false"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :debounceVerticalScrollbar="true"
        :debug="false"
        @column-resized="onColumnResized">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
// import CellRendererRoles from './cell-renderer/CellRendererRoles.vue'
// import CellRendererActions2 from './cell-renderer/CellRendererActions2.vue'
import CellRendererComments from './cell-renderer/CellRendererComments.vue'
// import CellRendererAdvisor from './cell-renderer/CellRendererAdvisor.vue'

import BtnCellRenderer from './btn-cell-renderer.js'

//sidebars
import EditDataClientsPDNViewSidebar from './EditDataClientsPDNViewSidebar.vue'
import ChangeInmigrationViewSidebar from './ChangeInmigrationViewSidebar.vue'

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    // CellRendererRoles,
    // CellRendererActions2,
    CellRendererComments,
    // CellRendererAdvisor,
    VuePerfectScrollbar,

    //sidebars
    'DataViewSidebar': EditDataClientsPDNViewSidebar,
    'DataViewSidebarChangeInmigration': ChangeInmigrationViewSidebar
  },
  data () {
    return {
      val:'',
      // Data Sidebar Edit Data Client
      addNewDataSidebarEditDataClientPDN: false,
      sidebarDataEditDataClientPDN: {},

      // Data Sidebar Inmigration
      addNewDataSidebarChangeInmigration: false,
      sidebarDataChangeInmigration: {},

      params: {
        data: {
          assignedAdvisor: {
            id_assigned_advisor: null
          },
          id_client: null,
          names_client: null,
          surnames_client: null
        }
      },

      email: null,
      password: null,
      password_confirmation: null,
      names_client: null,
      surnames_client: null,
      phone_mobile_client: null,
      id_country: 1,
      id_first_nationality: 1,
      id_second_nationality: 1,
      activePrompt: false,
      activePromptRemoveInmigration: false,
      activePromptChangePassword: false,
      activePromptChangeAdvisor: false,
      id_client: null,
      id_employee: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      searchQuery: '',
      // AgGrid
      gridApi: null,
      gridOptions: {
        // rowHeight: 60
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true, 
        editable: false
      },
      columnDefs: [
        // {
        //   headerName: '#',
        //   colId: 'rowNum',
        //   valueGetter: 'node.id',
        //   width: 40,
        //   pinned: 'left'
        // },
        // {
        //   headerName: 'Opciones',
        //   field: 'transactions',
        //   width: 90,
        //   cellClass: 'cell-items-center',
        //   pinned: 'left'
        //   // cellRendererFramework: 'CellRendererActions2'
        // },
        {
          headerName: 'Opciones',
          field: 'id_client',
          width: 200,
          cellRenderer: 'btnCellRenderer',
          pinned: 'left',
          colId: 'params'
        },
        {
          headerName: 'Cliente',
          field: 'names_client',
          filter: true,
          width: 250,
          pinned: 'left',
          cellRendererFramework: 'CellRendererLink',
          // getQuickFilterText: params => {
          //   return `${params.data.names_client} ${params.data.surnames_client}`
          // },
          cellClass: 'cell-wrap-text'
          // autoHeight: true
        },
        {
          headerName: 'ID',
          field: 'id_client',
          width: 100,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '',
          field: '',
          filter: false,
          width: 35,
          pinned: 'left',
          cellRendererFramework: 'CellRendererComments',
          cellClass: 'cell-items-center'
        },
        {
          headerName: 'Email',
          field: 'email_user',
          filter: true,
          width: 200,
          editable: true
        },
        {
          headerName: 'Teléfono',
          field: 'phone_mobile_client',
          filter: true,
          width: 160,
          editable: true
        },
        {
          headerName: 'Asesor',
          field: 'assignedAdvisor.full_name_employee',
          filter: true,
          // cellRendererFramework: 'CellRendererAdvisor',
          width: 100,
          cellClass: 'cell-wrap-text'
        },
        // {
        //   headerName: 'Rol Cliente',
        //   field: 'roles',
        //   filter: false,
        //   cellRendererFramework: 'CellRendererRoles',
        //   // valueFormatter (params) {
        //   //   return params.value.map(item => item.name_role).toString()
        //   // },
        //   getQuickFilterText: params => {
        //     return params.value.map(item => item.name_role).toString()
        //   },
        //   width: 150,
        //   cellClass: 'cell-wrap-text',
        //   autoHeight: true
        // },
        {
          headerName: 'Rol Cliente',
          field: 'roles',
          filter: false,
          // cellRendererFramework: 'CellRendererRoles',
          // valueFormatter (params) {
          //   return params.value.map(item => item.name_role).toString()
          // },
          // getQuickFilterText: params => {
          //   return params.value.map(item => item.name_role).toString()
          // },
          valueGetter (params) {
            return `${params.data.roles.map(item => item.name_role)}`
          },
          valueSetter: 'params',
          width: 300,
          cellClass: 'cell-wrap-text',
          autoHeight: true
        },
        {
          headerName: '1ra Nacionalidad',
          field: 'name_first_nationality',
          filter: true,
          width: 135
        },
        {
          headerName: 'Cliente desde',
          field: 'startDate.created_at_added_service',
          filter: true,
          valueFormatter (params) {
            return `${new Date(params.value).getDate()}-${new Date(params.value).getMonth() + 1}-${new Date(params.value).getFullYear()}`
          },
          width: 120
        },
        {
          headerName: 'Acceso',
          field: 'flag_login_user',
          filter: true,
          width: 100,
          valueFormatter (params) {
            return (params.value === 1) ?  'Activo' : 'Inactivo'
          },
          cellClass: 'cell-items-center'
        }
      ],

      frameworkComponents: {
        btnCellRenderer: BtnCellRenderer
      },
      context: { componentParent: this },

      // Cell Renderer Components
      components: {
        CellRendererLink,
        // CellRendererRoles,
        // CellRendererActions2,
        // CellRendererAdvisor,
        CellRendererComments
      }
    }
  },
  watch: {
    // client_type_filter (obj) {
    //   this.setColumnFilter('roles', obj.value)
    // },
    // client_status_access_filter (obj) {
    //   this.setColumnFilter('flag_login_user', obj.value)
    // }
  },
  computed: {
    validWord () {
      return (this.val.length > 0 && this.val === 'remover extranjería')
    },
    isFormValid () {
      return !this.errors.any() && this.password && this.password_confirmation
    },
    usersData () {
      const usersData = this.$store.state.clientsPDN
      return usersData.sort((a, b) => b.id_client - a.id_client)
    },
    countries () {
      return this.$store.state.countries
    },
    employees () {
      return this.$store.state.employees
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 25
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    isFormValidChangeAdvisor () {
      return !this.errors.any() && this.id_employee
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onGridReady (params) {
    },
    // eslint-disable-next-line no-unused-vars
    editDataClient (data) {
      // this.activePrompt = true
      this.sidebarDataEditDataClientPDN = data
      this.toggleDataSidebarEditDataClientPDN(true)
    },
    openModalRemoveInmigration (data) {
      this.params.data = data
      this.activePromptRemoveInmigration = true
    },
    confirmRemoveInmigration () {
      const obj = {
        id: this.params.data.id_client
      }
      this.$store.dispatch('removeInmigrationService', obj)
        .then(() => {
          this.$vs.notify({
            title: 'Servicio Inmigracion removido',
            text: 'Se ha removido un servicio de inmigración',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          }) 
        })
        .then(() => {
          this.$store.dispatch('fetchClientsPDN')
            .catch(err => { 
              console.error(err)
              this.$vs.notify({
                title: 'Error',
                text:  `${err.response.data.error}`,
                color: 'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle',
                time:6000
              })
            })
        })
        .catch(err => { 
          this.$vs.loading.close()
          console.error(err)
          const mensaje_error = err.response.data.error
          if (typeof mensaje_error === 'string') {
            this.$vs.notify({
              title: 'Error',
              text: `${mensaje_error}`,
              color: 'warning',
              iconPack: 'feather',
              icon:'icon-x-circle',
              time: 6000
            })
          } else {
            const array_errors = Object.entries(mensaje_error)
            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          }
        })
    },
    toggleDataSidebarEditDataClientPDN (val = false) {
      this.addNewDataSidebarEditDataClientPDN = val
    },
    openModalChangePassword (data) {
      this.params.data = data
      this.activePromptChangePassword = true
    },
    changePassword () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.params.data.id_client,
            user_type: 'client',
            password: this.password,
            password_confirmation: this.password_confirmation
          }
          this.$vs.loading()
          this.$store.dispatch('updatePasswordClientPDN', obj)
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Contraseña actualizada',
                text: 'La contraseña de un cliente del portal ha sido actualizada',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              // console.log(Object.getOwnPropertyNames(err))
              console.error(err)
              // console.log(err.response.data.errors)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)

              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
          this.initValues()
        }
      })
    },
    openModalChangeAdvisor (data) {
      console.log(data)
      this.params.data = data
      this.activePromptChangeAdvisor = true
    },
    changeAdvisor () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.params.data.assignedAdvisor.id_assigned_advisor,
            employee_id: this.id_employee
          }
          this.$vs.loading()
          this.$store.dispatch('updateItemAssignedAdvisor', obj)
            .then(() => { this.$emit('closeSidebarSuccess') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Asesor cambiado',
                text: 'Se ha cambiado el asesor de un cliente',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .then(() => { this.initValues() })
            .then(() => {
              this.$store.dispatch('fetchClientsPDN')
                .catch(err => { 
                  console.error(err)
                  this.$vs.notify({
                    title: 'Error',
                    text:  `${err.response.data.error}`,
                    color: 'danger',
                    iconPack: 'feather',
                    icon:'icon-alert-circle',
                    time:6000
                  })
                })
            })
            .catch(err => { 
              this.$vs.loading.close()
              // console.log(Object.getOwnPropertyNames(err))
              console.error(err)
              // console.log(err.response.data.errors)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)

              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Error',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    changeInmigrationService (data) {
      const obj = {
        id_client: data.id_client
      }
      this.sidebarDataChangeInmigration = data
      this.$store.dispatch('fetchClientPerfil', obj).catch(error => console.log(error))
      this.$store.dispatch('fetchServices').catch(error => console.log(error))
      this.$store.dispatch('fetchPaymentsForAClient', obj).catch(error => console.log(error))
      this.$store.dispatch('fetchVisaTypes', obj).catch(error => console.log(error))
      this.toggleDataSidebarChangeInmigration(true)
    },
    toggleDataSidebarChangeInmigration (val = false) {
      this.addNewDataSidebarChangeInmigration = val
    },
    openCloseModal () {
      this.initValues()
      this.activePrompt = !this.activePrompt
    },
    initValues () {
      this.email = null
      this.password = null
      this.password_confirmation = null
      this.names_client = null
      this.surnames_client = null
      this.phone_mobile_client = null
      this.id_country = 1
      this.id_first_nationality = 1
      this.id_second_nationality = 1
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation
          }
          const obj2 = {
            names: this.names_client,
            surnames: this.surnames_client,
            first_nationality_id: this.id_first_nationality,
            second_nationality_id: this.id_second_nationality,
            phone_mobile: this.phone_mobile_client,
            country_id: this.id_country
          }
          this.$vs.loading()
          this.$store.dispatch('addItemClientPDN', obj)
            .then((res) => {
              this.$vs.notify({
                title: 'Cliente creado',
                text: 'Ha sido registrado un nuevo cliente',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              })
              const obj3 = {
                id_client: res.data.client_id
              }
              const mergedObj = {
                ...obj2,
                ...obj3
              }
              this.$store.dispatch('updateClientPerfil', mergedObj)
                .then(() => { this.$vs.loading.close() })
                .then(() => {
                  this.$vs.notify({
                    title: 'Datos cliente actualizados',
                    text: 'Ha sido actualizado un cliente',
                    color: 'success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    time: 4000
                  })
                  this.updateListClientsPDN()
                })
                .catch(err => { 
                  this.$vs.loading.close()
                  console.error(err)
                  const mensaje_error = err.response.data.errors
                  const array_errors = Object.entries(mensaje_error)
                  for (let i = 0; i < array_errors.length; i++) {
                    this.$vs.notify({
                      title: 'Registro Fallido',
                      text: `${array_errors[i][1][0]}`,
                      iconPack: 'feather',
                      icon: 'icon-x-circle',
                      color: 'warning',
                      time: 6000
                    })
                  }
                })
            })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)
              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
          this.initValues()
        }
      })
    },
    sizeToFit () {
      this.gridApi.sizeColumnsToFit()
    },
    autoSizeAll () {
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds)
    },
    onColumnResized () {
      this.gridApi.resetRowHeights()
    },
    updateListClientsPDN () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarClientsPDN() }.bind(this), 0)
    },
    refrescarClientsPDN () {
      this.$store.dispatch('fetchClientsPDN')
        .then(() => { this.$vs.loading.close() })
    },
    refreshCard (card) {
      this.$store.dispatch('fetchClientsPDN')
      card.removeRefreshAnimation(500)
    },
    addNewData () {
      this.sidebarDataAddClientPDN = {}
      this.toggleDataSidebarAddClientPDN(true)
    },
    toggleDataSidebarAddClientPDN (val = false) {
      this.addNewDataSidebarAddClientPDN = val
    },
    exportarCsvSelected () {
    //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: true,
        fileName: 'ClientesPDN-Seleccionados'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    exportarCsvAll () {
      //AQUÍ PARÁMETROS DE EXPORTACIÓN
      const params = {
        onlySelected: false,
        fileName: 'ClientesPDN-Todos'
      }
      this.gridApi.exportDataAsCsv(params)
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'Todos') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.client_type_filter = { label: 'Todos', value: 'Todos' }
      this.client_status_access_filter = { label: 'Todos', value: 'Todos' }
      this.country_origin_filter2 = {name_country: 'Todos', value: 'Todos'}

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    if (!this.$store.state.clientsPDN) {
      this.$store.dispatch('fetchClientsPDN')
        .catch(err => { 
          console.error(err)
          this.$vs.notify({
            title: 'Error',
            text:  `${err.response.data.error}`,
            color: 'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle',
            time:6000
          })
        })
    }
    if (this.$store.state.countries.length === 0) {
      this.$store.dispatch('fetchCountries').catch(err => { console.error(err) })
    }
    if (this.$store.state.employees.length === 0) {
      this.$store.dispatch('fetchEmployees').catch(err => { console.error(err) })
    }
  }
}

</script>

<style lang="scss">
.con-exemple-prompt {
  overflow-x:hidden;
}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.ag-theme-material .ag-header-cell {
  padding-left: 5px;
  padding-right: 5px;
}

.ag-theme-material .ag-ltr .ag-floating-filter-button {
  margin-left: 0px;
}

.ag-theme-material .ag-cell {
  padding-left: 5px;
  padding-right: 5px;
}

.cell-wrap-text {
    white-space: normal !important;
    line-height:20px!important;
    display: flex;
    align-items: center;
}

.cell-items-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.ancho-dropdown {
  width: 15rem;
}
</style>
